"use strict";

exports.__esModule = true;
exports.protobufConverters = void 0;
var _timestamp = require("./timestamp");
var _fieldMask = require("./field-mask");
var _bytes = require("./bytes");
var _duration = require("./duration");
var _float = require("./float");
const protobufConverters = exports.protobufConverters = [_timestamp.timestamp, _fieldMask.fieldMask, _bytes.bytes, _duration.duration, _float.float];
//# sourceMappingURL=converters.js.map